export const wheelBaseImage = require('../../invite-spin-base.webp');
export const wheelSpinImage = require('../../invite-spin-spin-all.png');
export const wheelCheckedImage = require('../../invite-spin-checked.webp');
export const wheelButtonImage = require('../../invite-spin-circle.webp');
export const wheelNeedleTopImage = require('../../invite-cash-zhen.webp');
export const wheelLightDarkImage = require('../../invite-spin-light-dark.webp');
export const wheelLightImage = require('../../invite-spin-light.webp');
export const referSpinBackinImage = require('../../refer-spin-backin.png');
export const referSpinBackImage = require('../../refer-spin-back.png');
export const referSpinPanImage = require('../../refer-spin-pan.png');
export const referSpinButtonImage = require('../../refer-spin-button.webp');
export const referSpinPointerImage = require('../../refer-spin-pointer.webp');
export const myAmountBgImage = require('../../invite-my-amount-bg.webp');
export const trumpetImage = require('../../trumpet.webp');
export const cashEverydayTitleImage = require('../../invite-cash-everyday.webp');
export const cashGiftImage = require('../../invite-cash-gift.webp');
export const cashGiftOpenMaxImage = require('../../invite-cash-gift-open-max.webp');
export const cashGiftOpenMinImage = require('../../invite-cash-gift-open-min.webp');
export const cashArrowLeftImage = require('../../invite-cash-arrow-left.png');
export const cashArrowRightImage = require('../../invite-cash-arrow-right.png');
export const congratulationBigCoinImage = require('../../invite-congratulation-bigcoin.webp');
export const congratulationShineImage = require('../../invite-congratulation-shine.webp');
export const sequentialCloseIconImage = require('@/assets/imgs/home-pk/close.webp');
export const specialDialogBgImage = require('@/assets/figma/20pan/tip-bg.webp');
export const randomRewardCoinImage = require('@/assets/figma/20pan/random-reward-coin.webp');
export const inviteCoinImage = require('@/assets/figma/20pan/invite-coin.webp');
export const coinImages = [
  require('../../invite-coin-1.webp'),
  require('../../invite-coin-2.webp'),
  require('../../invite-coin-3.webp'),
  require('../../invite-coin-4.webp'),
  require('../../invite-coin-5.webp'),
  require('../../invite-coin-6.webp'),
  require('../../invite-coin-7.webp'),
  require('../../invite-coin-8.webp'),
  require('../../invite-coin-9.webp'),
];
export const recordAvatarImage = require('@/assets/imgs/default-header.webp');

const preloadCache = new Map<string, Promise<void>>();

const preloadImage = (src: string) => {
  if (typeof window === 'undefined' || !src) {
    return Promise.resolve();
  }

  const cached = preloadCache.get(src);
  if (cached) {
    return cached;
  }

  const promise = new Promise<void>(resolve => {
    const image = new Image();
    image.onload = () => resolve();
    image.onerror = () => resolve();
    image.src = src;
  });

  preloadCache.set(src, promise);
  return promise;
};

export const cashEverydayPreloadImages = [
  cashEverydayTitleImage,
  cashGiftImage,
  cashGiftOpenMaxImage,
  cashGiftOpenMinImage,
  cashArrowLeftImage,
  cashArrowRightImage,
];

export const rewardModalPreloadImages = [
  ...cashEverydayPreloadImages,
  congratulationBigCoinImage,
  congratulationShineImage,
  wheelButtonImage,
  specialDialogBgImage,
  randomRewardCoinImage,
  inviteCoinImage,
];

export const wheelPreloadImages = [
  referSpinBackinImage,
  referSpinBackImage,
  referSpinPanImage,
  referSpinButtonImage,
  referSpinPointerImage,
  wheelLightDarkImage,
  wheelLightImage,
  trumpetImage,
  ...coinImages,
  recordAvatarImage,
];

export const preloadImages = (images: string[]) =>
  Promise.all(images.map(preloadImage)).then(() => undefined);

export const preloadReferEarnWheelImages = () =>
  preloadImages([...wheelPreloadImages, ...rewardModalPreloadImages]);

export const preloadCashEverydayImages = () =>
  preloadImages(cashEverydayPreloadImages);

export const preloadRewardModalImages = () =>
  preloadImages(rewardModalPreloadImages);

export const waitForCashEverydayImages = (timeoutMs = 900) =>
  typeof window === 'undefined'
    ? preloadCashEverydayImages()
    : Promise.race([
        preloadCashEverydayImages(),
        new Promise<void>(resolve => {
          window.setTimeout(resolve, timeoutMs);
        }),
      ]);

export const waitForRewardModalImages = (timeoutMs = 480) =>
  typeof window === 'undefined'
    ? preloadRewardModalImages()
    : Promise.race([
        preloadRewardModalImages(),
        new Promise<void>(resolve => {
          window.setTimeout(resolve, timeoutMs);
        }),
      ]);
